<!--点击页码分页组件-->
<template>
  <ul class="pagination" >
    <li v-show="current != 1" @click="goto(currentPrev)" class="prev"><a href="#top"><img src="../assets/images/icon_prev.svg"></a></li>
    <li v-show="showFirst">
      <a href="#top" @click="goto(1)">1</a>
      <span class="ellipsis">...</span>
    </li>
    <li v-for="index in pages.slice(0,-1)" @click="goto(index)" :class="{'active':current == index}" :key="index">
      <a href="javascript:;">{{index}}</a>
    </li>
    <li v-for="index in pages.slice(-1)" @click="goto(index)" :class="{'active':current >= index }" :key="index">
      <a href="javascript:;">{{index}}</a>
    </li>
    <li v-show="total >current && total != 0 " @click="goto(currentNext)" class="next"><a href="#top"><img src="../assets/images/icon_next.svg"></a></li>
  </ul>
</template>

<script>
    export default {
        name: "pagination",//分页
        props:{
          total:{
            type:Number
        },
        current:{
            type:Number
        },
        currentPrev:{
            type:Number
        },
        currentNext:{
            type:Number
        },
        showFirst:{
            type:Boolean
        }
        },//总页数/当前页码
        data(){
          return{
            // current:4,//当前页码
            showItems:5,//显示分页按钮的个数
            // showFirst:false
          }

        },
        computed:{
          pages:function(){
            let pag = [];
            if( this.current < this.showItems ){ //如果当前的激活的项 小于要显示的条数
              //总页数和要显示的条数哪个大，就显示大的那个条数
              let i = Math.min(this.showItems,this.total)
              while(i){
                pag.unshift(i--)
              }
            }
            else{ //当前页数大于显示页数了
              let middle = this.current - Math.floor(this.showItems / 2 ),//从哪里开始
                i = this.showItems
              if( middle >  (this.total - this.showItems)  ){
                middle = (this.total - this.showItems) + 1
              }
              while(i--){
                pag.push( middle++ )
              }
            }
            return pag
          }
        },
        methods:{
          goto:function(index){ 
            if(index == this.current) return
            // this.current = index;//写法错误，不能在子组件中修改props中的current值，只能在父子组件进行修改
            //这里可以发送ajax请求
            this.$emit("gotoPage",index)//调用父组件的gotoPage方法，并传递参数index-1

            // if(this.current>=5){
            //   this.showFirst=true;
            // }else{
            //   this.showFirst=false;
            // }
          }

        }
    }
</script>

<style scoped>
  li{
    list-style:none;
  }
  a{
    text-decoration:none;
    color:#333;
  }
  .pagination {
    position: relative;
    justify-content: center;
  }
  .pagination li{
    display: inline-block;
  }
  .pagination li a{
    padding:6px 0;
    display:inline-block;
    border:none;
    background:#e6e6e6;
    color:#333;
    border-radius:50%;
    margin: 0 5px;
    width: 32px;
    height: 32px;
    line-height: 22px;
    text-align: center;
  }
  .pagination li a:hover{
    background: #dbdbdb;
  }
  .pagination li a:visited{
    border-color:#dbdbdb;
  }
  .pagination li.active a{
    background:#C6A85B;
    color:#fff !important;
  }
  li.prev a,li.next a{
    width: 32px;
    height: 32px;
    padding: 6px 8px;
  }
  .ellipsis{
    padding: 0;
    border:none;
    color:#333;
    margin-top: 2px;
  }
  .ellipsis:hover{
    background: transparent;
  }

</style>
